// src/appRedux/reducers/Spares.js
import {
  SET_WAREHOUSE_LIST,
  SET_WH_LOADING,
  SET_WH_MODAL_LOADING,
  SET_SPARE_TRACK_LOADING,
  SET_SPARE_TRACKING_DATA,
  SET_SPARE_RETURN_LOADING,
  SET_DOA_SPARES,
  SET_DOA_SPARES_LOADING,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  warehouseList: [],
  whLoading: false,
  whModalLoading: false,
  spareTracking: [],
  spareTrackLoading: false,
  spareReturnLoading: false,
  doaSpares: [],
  doaSparesLoading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_WAREHOUSE_LIST:
      return { ...state, warehouseList: action.payload };
    case SET_WH_LOADING:
      return { ...state, whLoading: action.payload };
    case SET_WH_MODAL_LOADING:
      return { ...state, whModalLoading: action.payload };
    case SET_SPARE_TRACKING_DATA:
      return { ...state, spareTracking: action.payload };
    case SET_SPARE_TRACK_LOADING:
      return { ...state, spareTrackLoading: action.payload };
    case SET_SPARE_RETURN_LOADING:
      return { ...state, spareReturnLoading: action.payload };
    case SET_DOA_SPARES:
      return { ...state, doaSpares: action.payload };
    case SET_DOA_SPARES_LOADING:
      return { ...state, doaSparesLoading: action.payload };
    default:
      return state;
  }
};
